import type { FC } from 'react';
import { z } from 'zod';

import { FullPageContent } from '@/components/layout/full-page-content';
import { Dashboard } from '@/components/looker/dashboard';
import { codec, useQueryParams } from '@/hooks/router/use-query-params';

export const DataCompatibilityPage: FC = () => {
  const [{ top_id }] = useQueryParams({
    top_id: {
      key: 'top_id',
      schema: z.string().optional(),
      codec: codec.string,
    },
  });

  return (
    <FullPageContent testId="data-compatibility-page">
      <Dashboard id="compatibility" filters={{ top_id }} />
    </FullPageContent>
  );
};
